import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

interface CustomAllocationContentProps {
  onTotalChange?: (total: number) => void;
}

const CustomAllocationContent = ({ onTotalChange }: CustomAllocationContentProps) => {
  const [allocations, setAllocations] = useState({
    Stocks: 25,
    Bonds: 25,
    Cash: 25,
    Alternatives: 25
  });

  useEffect(() => {
    if (onTotalChange) {
      const total = Object.values(allocations).reduce((sum, value) => sum + value, 0);
      onTotalChange(total);
    }
  }, [allocations, onTotalChange]);

  const handleAllocationChange = (asset: keyof typeof allocations, value: string) => {
    const numValue = parseFloat(value) || 0;
    setAllocations(prev => ({
      ...prev,
      [asset]: numValue
    }));
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        {Object.entries(allocations).map(([asset, value]) => (
          <div key={asset} className="flex items-center gap-4">
            <label className="w-32 text-navy-light">{asset}</label>
            <Input
              type="number"
              value={value}
              onChange={(e) => handleAllocationChange(asset as keyof typeof allocations, e.target.value)}
              className="w-24"
              min="0"
              max="100"
            />
            <span className="text-navy-light">%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomAllocationContent;